export default function UnderlinedTitle({ text }: { text: string }) {
  return (
    <>
      <div className=" text-main text-[20px] md:text-[27px] font-bold text-center  pb-2 ">
        {text}
      </div>
      <hr className="w-16 border-[2px] border-main m-auto" />
    </>
  );
}
